<vs-dialog #emailTemplatePreviewDialog [config]="{ dialogContainerClass: 'max-w-[846px] w-full' }">
  <vs-dialog-header
    [config]="{
      mode: 'simple',
      hideCloseButton: false,
      icon: 'eye',
      iconTheme: 'primary',
      showDivider: true,
      title: 'Email Preview: ' + (template?.type ?? ''),
      subtitle: 'Preview the email sent from organization settings'
    }"
  ></vs-dialog-header>

  <div class="flex flex-col p-4 pt-8 gap-4">
    <div class="border border-gray-300 rounded-lg py-3 px-6">{{ template?.subject }}</div>

    <div class="max-w-[14rem]">
      <vs-input-container>
        <label slot="start">Format</label>
        <vs-select [value]="previewFormat" (valueChanges)="setPreviewFormat($event)">
          <li vs-select-option value="html">HTML</li>
          <li vs-select-option value="text">Plain text</li>
        </vs-select>
      </vs-input-container>
    </div>

    <div class="border border-gray-300 max-h-[502px] h-full overflow-auto rounded-lg">
      @if (previewFormat === 'text') {
      <div class="px-6">
        <pre class="py-6 whitespace-pre-wrap break-words text-sm text-gray-900 font-mono">{{ contentPreviewText }}</pre>
      </div>
      } @else {
      <div class="px-6">
        <div class="flex flex-row items-center justify-start py-6">
          <img [src]="tenantLogo" [alt]="tenantName" height="40" width="150" />
        </div>
        @if (template !== null && template.byline) {
        <p class="text-gray-500 text-xs uppercase tracking-wide pb-2">{{ template.byline }}</p>
        }
        <div class="pt-2" [innerHTML]="(template?.content ?? '') | safe: 'html'"></div>
        @if (emailButton) {
        <div class="py-6">
          <button vs-button theme="primary" appearance="default" size="lg">{{ emailButton }}</button>
        </div>
        }
      </div>
      }
    </div>
  </div>
</vs-dialog>
